"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { Button, Dialog, DialogBody, DialogContent, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export function JobSeekerDialog() {
  const pathname = usePathname();
  const clientConfig = useClientConfig();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="font-bold w-full flex text-base p-6">Lamar Sekarang</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogTitle></DialogTitle>
        <DialogBody>
          <div>
            <Image
              src="/job-seeker-registration.webp"
              alt="Job seeker registration"
              width="224"
              height="224"
              className="h-[224px] w-auto object-contain mx-auto"
            />
            <div className="text-center space-y-4 mt-6">
              <h6 className="text-xl font-bold">Belum terdaftar sebagai pencari kerja</h6>
              <div className="text-gray-600">
                Anda belum terdaftar sebagai pencari kerja, silahkan klik tombol di bawah ini untuk mendaftar sebagai pencari kerja terlebih
                dahulu sebelum melamar lowongan ini.
              </div>
            </div>
            <div className="mt-10 flex items-center justify-center text-center">
              <Button className="font-bold text-base p-6" asChild>
                <Link
                  href={
                    clientConfig?.config.siapkerjaAppUrl +
                    "/prohub/job-seeker/dashboard?redirect_url=" +
                    clientConfig?.config.appUrl +
                    pathname
                  }
                >
                  Daftar Sebagai Pencari Kerja
                </Link>
              </Button>
            </div>
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
